import Issues from ".";
import { toIssueDetail } from "../IssuesDetail/helpers/dataHelpers";
import { submitIssue } from "../IssuesDetail/services";

export const IssuesDefault = (props) => <Issues {...props} submitIssue={submitIssue} toIssueDetail={toIssueDetail} />;

 